import * as React from 'react';

import { Grid } from "@material-ui/core";
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { MarketShareBookstoreShareBilling } from './billing/MarketShareBookstoreShareBilling';
import { MarketShareBookstoreShareBillingMarket } from './billingMarket/MarketShareBookstoreShareBillingMarket';
import { MarketShareBookstoreShareRanking } from './ranking/MarketShareBookstoreShareRanking';
import { MarketShareBookstoreShareMarket } from './market/MarketShareBookstoreShareMarket'
import { QueryFilter, QUERY_FILTER_MARKET_BOOKSTORE } from '../../../shared';
import { MarketShareBookstoreShareAverageTicketEvolution } from './average-ticket-evolution/MarketShareBookstoreShareAverageTicketEvolution';
import { MarketShareBookstoreShareAverageTicket } from './average-ticket/MarketShareBookstoreShareAverageTicket';
import { MarketShareBookstoreShareBillingEvolutionByMonth } from './billing-evolution-by-month/MarketShareBookstoreShareBillingEvolutionByMonth';

const BILLING_MARKET_QUERY = gql`
query marketShareBookstoreShareBillingMarket($customFilter: MarketShareCustomFilter) {
    marketShareBookstoreShareBillingMarket(marketShareCustomFilter: $customFilter) {
        current_year,
		last_year
  }
}
`;

const BILLING_QUERY = gql`
query marketShareBookstoreShareBilling($customFilter: MarketShareCustomFilter) {
    marketShareBookstoreShareBilling(marketShareCustomFilter: $customFilter) {
        current_year,
		last_year
  }
}
`;

const AVERAGE_TICKET_EVOLUTION_QUERY = gql`
query marketShareBookstoreShareAverageTicketEvolution($customFilter: MarketShareCustomFilter) {
    marketShareBookstoreShareAverageTicketEvolution(marketShareCustomFilter: $customFilter) {
        day,
        average_ticket,
        average_ticket_market
  }
}
`;

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreShareProps {
    bookstoreMenuValue: number;
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreShareState {
    customFilter: {
        isChart: boolean
    },
}

export class MarketShareBookstoreShare extends React.Component<IMarketShareBookstoreShareProps, IMarketShareBookstoreShareState> {
    constructor(props: IMarketShareBookstoreShareProps) {
        super(props);
        this.state = {
            customFilter: {
                isChart: true,
            },
        }
    }

    public render() {
        const jsonFilter = {
            "customFilter": {
                "isChart": this.state.customFilter.isChart,
            }
        };
        return(
            <Query query={QUERY_FILTER_MARKET_BOOKSTORE} notifyOnNetworkStatusChange={true} >
            {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {
                return (
                    <Query query={BILLING_MARKET_QUERY} variables={QueryFilter.getFilterMarketBookstore(clientC, jsonFilter, [], false)} >
                        {({ loading:loadingBillingMk, error:errorBillingMk, data:dataBillingMk}) => {
            
                            return(
                                <Query query={BILLING_QUERY} variables={QueryFilter.getFilterMarketBookstore(clientC, jsonFilter, [], false)} >
                                {({ loading:loadingBilling, error:errorBilling, data:dataBilling}) => {
                                    return (
                                        <Query query={AVERAGE_TICKET_EVOLUTION_QUERY} variables={QueryFilter.getFilterMarketBookstore(clientC, jsonFilter, [], false)} >
                                        {({ loading: loadingAvgTicket, error:errorAvgTicket, data:dataAvgTicket}) => {
                                            return (
                                                <Grid container={true} spacing={16}>
                                                    {this.props.bookstoreMenuValue === 0 && <Grid item={true} xs={6} sm={6}>
                                                        <MarketShareBookstoreShareBilling 
                                                            data={dataBilling}
                                                            loading={loadingBilling}
                                                        />
                                                    </Grid>}

                                                    {this.props.bookstoreMenuValue === 0 && <Grid item={true} xs={6} sm={6}>
                                                        <MarketShareBookstoreShareBillingMarket 
                                                            data={dataBillingMk}
                                                            loading={loadingBillingMk}
                                                        />
                                                    </Grid>}

                                                    {this.props.bookstoreMenuValue === 0 && <Grid item={true} xs={6} sm={6}>
                                                        <MarketShareBookstoreShareRanking />
                                                    </Grid>}

                                                    {this.props.bookstoreMenuValue === 0 && <Grid item={true} xs={6} sm={6}>
                                                        <MarketShareBookstoreShareAverageTicket data={dataAvgTicket} loading={loadingAvgTicket} />
                                                    </Grid>}

                                                    {this.props.bookstoreMenuValue === 0 && <Grid item={true} xs={12} sm={12}>
                                                        <MarketShareBookstoreShareMarket dataBilling={dataBilling} dataBillingMk={dataBillingMk} loading={loadingBilling && loadingBillingMk} />
                                                    </Grid>}
        
                                                    {this.props.bookstoreMenuValue === 1 && <Grid item={true} xs={12} sm={12}>
                                                        <MarketShareBookstoreShareAverageTicketEvolution data={dataAvgTicket} loading={loadingAvgTicket} />
                                                    </Grid>}

                                                    {this.props.bookstoreMenuValue === 1 && <Grid item={true} xs={12} sm={12}>
                                                        <MarketShareBookstoreShareBillingEvolutionByMonth filter={[]} />
                                                    </Grid>}
                                                </Grid>
                                            );
                                        }}
                                        </Query>
                                    );
                                }}
                                </Query>
                            );
                        
                        }}
                    </Query>
                )
            }}
            </Query>
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/market/bookstore/marketShare/MarketShareBookstoreShare.tsx